<template>
  <v-btn
    :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
    color="primary"
    outlined
    :data-cy="'btn_voltar_passo_' + index"
    @click="setAnterior"
  >
    Voltar
  </v-btn>
</template>

<script>
export default {
  name: 'BtnVoltar',

  props: {
    index: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    setAnterior() {
      if (this.index === 1) {
        this.$router.go(-1);
      } else {
        this.$emit('irParaAnterior', this.index - 1);
      }
    },
  },
};
</script>
